import {
  Box,
  Typography,
  Button,
  Snackbar,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ja } from "date-fns/locale";
import { usePendingShipment } from "../hooks/logic/usePendingShipment";
import { isNotGeneralUser } from "../constants/roles";
import { PendingShipmentStyle as styles } from "./PendingShipmentStyle";
import SearchByGenre from "../components/SearchByGenre";
import UserFilterSelect from "../components/UserFilter";
import ProductInfoDialog from "../components/ProductInfoDialog";
import PendingShipmentTable from "../components/PendingShipment/PendingShipmentTable";
import ShipmentDialog from "../components/ShipmentDialog";

const PendingShipment = () => {
  const {
    inputRef,
    loginUser,
    pendingShipmentList,
    userOptions,
    selectedUserId,
    handleUserChange,
    checkedIds,
    handleCheckChange,
    searchGenres,
    selectedGenreId,
    setSelectedGenreId,
    focusInputField,
    handleGenreChange,
    searchKeyword,
    setSearchKeyword,
    searchItems,
    resetFilter,
    resetGenreWord,
    handleKeywordChange,
    handleRowClick,
    detailDialogOpen,
    setDetailDialogOpen,
    toastOpen,
    toastMessage,
    toastSeverity,
    handleCloseToast,
    planInfoDetail,
    handleBackStatus,
    isCancelLoading,
    // handlePageChange,
    totalListCount,
  } = usePendingShipment();

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
      <ShipmentDialog
        open={detailDialogOpen}
        onClose={() => {
          // setSelectedParent(null);
          setDetailDialogOpen(false);
        }}
        statusId={4}
        planInfoDetail={planInfoDetail!}
      />
      <Box sx={styles.titleBar}>
        <Typography variant="h6" sx={styles.titleText}>
          出荷待ち
        </Typography>
      </Box>
      <Box py={0} px={0}>
        <Box display="flex" px={1} justifyContent="space-between">
          <Box display="flex" flexDirection="column" gap={2}>
            <Box display="flex" gap={2} flexWrap="wrap" alignItems="flex-start">
              {isNotGeneralUser(loginUser?.permissionId) && (
                <UserFilterSelect
                  options={userOptions}
                  onSelect={handleUserChange}
                  value={selectedUserId}
                  sx={{ width: "300px" }}
                />
              )}
              <Button
                variant="outlined"
                onClick={async () => {
                  await resetFilter();
                }}
              >
                フィルター解除
              </Button>
            </Box>
            <Box display="flex" gap={2} mb={2} flexWrap="wrap">
              <SearchByGenre
                options={["プラン名", "問い合わせNO", "記入済"]}
                defaultGenre="プラン名"
                onGenreChange={handleGenreChange}
                searchKeyword={searchKeyword}
                onKeywordChange={setSearchKeyword}
                autoFocus={true}
                onEnter={focusInputField}
              />

              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  searchItems(searchKeyword);
                }}
              >
                検索
              </Button>
            </Box>
          </Box>

          <Box
            display="flex"
            justifyContent="flex-end"
            alignItems="flex-start"
            gap={4}
            mb={2}
          ></Box>
        </Box>

        <Box mt={2}>
          <PendingShipmentTable
            data={pendingShipmentList}
            totalListCount={totalListCount}
            checkedIds={checkedIds}
            onCheckedChange={handleCheckChange}
            onParentRowClick={handleRowClick}
            handleBackStatus={handleBackStatus}
            // onPageChange={handlePageChange}
            loginUser={loginUser}
          ></PendingShipmentTable>
        </Box>
        <Backdrop
          open={isCancelLoading}
          sx={{
            zIndex: (theme) => theme.zIndex.drawer + 1000,
            color: "#fff",
          }}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Box>
      <Snackbar
        open={toastOpen}
        autoHideDuration={4000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={handleCloseToast}
          severity={toastSeverity}
          sx={{ width: "100%", whiteSpace: "pre-line" }}
          elevation={6}
          variant="filled"
        >
          {toastMessage}
        </MuiAlert>
      </Snackbar>
    </LocalizationProvider>
  );
};

export default PendingShipment;
